import { atom } from 'jotai';

// Taken from https://jotai.org/docs/recipes/atom-creators#atomwithtoggle
export function atomWithToggle(initialValue?: boolean) {
  const anAtom = atom(initialValue, (get, set, nextValue?: boolean) => {
    const update = nextValue ?? !get(anAtom);
    set(anAtom, update);
  });

  return anAtom;
}
